/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![StageLockIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAACwklEQVR4nMVWy2pUQRCND3wSExFEVHSlAT/BB4NiYHCmq+oGeqrykEGCwYXRjZsYNSoRx51f4BeIGqKCoguNbgQl2UaMghoFBZWYKEiMdN/qmWvmpWCwoRfdXVXn1Knuureh4X8OxHwzkBwG4utA8hxIfhjiT0AyYYivGeRua23TXwe21i4D4jMG5TOQzNWaBmUKiPtT+fyKPwp+oK1jK6A8LQZBuQOQO0TE21Op1FI3AWyL2wOSe0Ug4mfZrN1SN7gheRkH5nFE3lmPECLvUfnmDPLrKOrcXF2WwBx5BAAaPai1GwzKIKCMAvK3eMookJyPoq716tsEKI8041EXqwzAIJ8NzNPpzjV+jyRXuw78xdmUQHhcMzk9L818cwgUZImD86zqOwSQ2+uystauNJHsA5TbGmwWIrYJuTxwUCBmT9wTChpk8Ubkjfur6e/OQkDn4/eQ7yupniTAULwp+dhRLijgcLE+xJcM8qQhfgskhaCzIb6l13VQpe5W0KslJsgv3GamrX2bMhvzTpG0KmChQg0K/gxy+zXgWLy2LXo+kUhVvrvNdDq9PGYhMx4w07FWWU2WAaC8c2dEB9dpBjNunc1mV6nNdBJguhJAaAMqy/wM3qj7IiB+D8Qf3KK1tWt1OQDyqyoSpatJZFAuFv0BGh1zrdcSQ/Lgd4lQbiSL7B9WfBOOloosBZfJ/CJXGgMDA4szGbupwjXlu0FXg3wy1KDeAOLj/ob5Kb1lBvrQpjzrttyu5Jl17CM5BihPQqswJFdKvvq4UIYN8k0g+Zml9t0VWMgp1fZySVvZGOqRnFnkE6XspS9cEDdV6r4yANfPDco5ALvDrb0x+qZW1oNCkzMkj6v2KeSRmrq6AldzTmRd82NUu3B6s2ChABDbDRB/XTAAN3yPJzmi2Uy4lmKQP/4zgHrDf/mq/QyQPHRGvwDmSEayuFdfEQAAAABJRU5ErkJggg==)
 */
export const StageLockIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.92 14.08c.32.27.86.15.93-.26A11 11 0 1 0 2.91 18.2c.34.5 1.05.51 1.46.07l.02-.02c.33-.36.34-.91.07-1.33a9 9 0 1 1 16.48-3.88c-.03.22.1.44.29.55.24.14.48.3.7.49Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M13.48 16.18c.39.1.45.62.2.93A2.99 2.99 0 0 0 13 19v3.5c0 .26-.2.47-.46.49a11.16 11.16 0 0 1-5.4-1.12 1.52 1.52 0 0 1-.8-1.84 6 6 0 0 1 7.14-3.85ZM18.98 12.58c-.02.24-.23.42-.48.45-.18.02-.35.05-.53.09-.45.1-1-.36-.98-.82L17 12a5 5 0 1 0-9.6 1.94c.17.42.13.9-.18 1.23l-.05.06c-.43.47-1.18.42-1.45-.14a7 7 0 1 1 13.26-2.51Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M16.5 18H16a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-.5v-.5a2.5 2.5 0 0 0-5 0v.5Zm3.5 0v-.5a1 1 0 1 0-2 0v.5h2Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
